import axiosMapInstance from "../interceptor/webMapInstance";

export const getAllCountries = async () => {
  const response = await axiosMapInstance.get(
    `${process.env.REACT_APP_BASE_URL_WEB_MAP}/country`
  );
  return response.data?.data || [];
};

export const getGeohashesByCountry = async (countryCode) =>{
  const response = await axiosMapInstance.get(
    `${process.env.REACT_APP_BASE_URL_WEB_MAP}/country/geohashes/${countryCode}`
  );
  return response.data;
}